<template>
  <header>
    <div class="header">
      <div class="mobile-nav">
        <button class="burger" @click="toggleMenu">
          <span :class="{ open: isOpen }"></span>
          <span :class="{ open: isOpen }"></span>
          <span :class="{ open: isOpen }"></span>
        </button>
        <BloxupLogo />
        <Teleport to="body">
          <MobileMenuModal :isOpen="isOpen" @close="isOpen = false" />
        </Teleport>
      </div>
      <div class="login-wrapper">
        <div class="login">
          <Button
            v-if="!accessToken"
            @click="$store.commit('auth/SHOW_LOGIN_MODAL', true)"
            style="height: 32px; width: 80px; border-radius: 12px"
            >Login</Button
          >
          <div v-else class="logged-in-user">
            <img :src="user.avatar" :alt="user.name" />
            <Dropdown :options="userOptions">
              <span>{{ user.name }}</span>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
    <div class="players">
      <div class="left-side">
        <Ping />
        <span>{{ $t("global.online_players") }}</span>
      </div>
      <div class="right-side">
        <span>{{ globalConfig.data.onlineUsersCount?.toLocaleString() }}</span>
      </div>
      <div class="shadow"></div>
    </div>
    <LoginModal
      v-if="showLoginModal"
      @close="$store.commit('auth/SHOW_LOGIN_MODAL', false)"
      img="Welcome.png"
      name="Welcome"
    />
  </header>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import Button from "@/components/uikit/Button.vue"
import { UserData } from "@/store/types"

import MobileMenuModal from "./MobileMenuModal.vue"
import { Ping } from "../icons"
import { mapActions } from "vuex"
import Dropdown, { DropdownOption } from "@/components/uikit/Dropdown.vue"
import RobloxConnect from "@/services/RobloxConnect"
import LoginModal from "@/components/login/mobile/index.vue"
import { AsyncState, Configs } from "../../store/types"
import BloxupLogo from "../BloxupLogo.vue"

export default defineComponent({
  name: "MobileNav",
  props: {},
  components: {
    MobileMenuModal,
    Button,
    Ping,
    Dropdown,
    LoginModal,
    BloxupLogo,
  },
  data() {
    return {
      isOpen: false,
      userOptions: [
        {
          label: "Logout",
          key: "logout",
          onClick: this.logout,
        },
      ] as DropdownOption[],
    }
  },
  computed: {
    showLoginModal(): boolean {
      return this.$store.getters["auth/showLoginModal"]
    },
    accessToken(): string | null {
      return this.$store.state.auth.tokenData.access_token
    },
    user(): UserData {
      return this.$store.state.auth.user
    },
    globalConfig(): AsyncState<Configs> {
      return this.$store.getters["global/data"]
    },
  },
  methods: {
    connectRoblox: RobloxConnect.connectRoblox.bind(RobloxConnect),
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    ...mapActions({
      logout: "auth/logout",
    }),
  },
  mounted() {
    if (this.user.is_admin) {
      this.userOptions.unshift({
        key: "admin-panel",
        label: "Admin Panel",
        onClick: () => this.$router.push("/admin"),
      })
    }
  },
})
</script>
<style scoped lang="scss">
header {
  position: fixed;
  display: flex;
  flex-direction: column;

  width: 100%;
  top: 0;
  left: 0;
  right: 0;

  .header {
    padding: 8px 16px;
    width: 100%;
    gap: 10px;
    height: 48px;
    box-sizing: border-box;
    background: rgba(33, 36, 41, 0.7);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px); // Safari support
    display: flex;
    justify-content: space-between;
  }

  .players {
    height: 32px;
    background: rgba(33, 36, 41, 0.6);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px); // Safari support
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    overflow: hidden;

    .left-side {
      display: flex;
      align-items: center;
      gap: 6px;
      span {
        font-family: "Montserrat";
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: -0.4px;

        color: #ffffff;
      }
    }
    .right-side {
      position: relative;
      z-index: 1;
      span {
        font-family: "Druk Text Wide Cyr";
        font-weight: 900;
        font-size: 14px;
        line-height: 20px;
        color: #ffffff;
      }
    }
    .shadow {
      position: absolute;
      width: 100px;
      height: 100px;
      right: -7px;
      top: 21px;
      background: var(--text-gradient);
      filter: blur(22px);
    }
  }

  z-index: 25;

  .nav {
    display: flex;
    gap: 40px;
  }

  .login-wrapper {
    align-items: center;
    display: flex;
    gap: 32px;
  }
  .mobile-nav {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    .burger {
      width: 24px;
      height: 24px;
      padding: 6px 3px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: none;
      border: none;
      cursor: pointer;
      z-index: 50;

      span {
        height: 2px;
        width: 100%;
        border-radius: 2px;
        transition: all 0.3s;

        background: #ffffff;

        &.open {
          &:nth-child(1) {
            transform: rotate(45deg) translate(3px, 4px);
          }
          &:nth-child(2) {
            opacity: 0;
          }
          &:nth-child(3) {
            transform: rotate(-45deg) translate(3px, -4px);
          }
        }
      }
    }
    .blox-up-text {
      width: 123px;
      height: 24px;

      font-family: "Druk Text Wide Cyr";
      font-style: normal;
      font-weight: 900;
      font-size: 16px;
      line-height: 24px;
      text-transform: uppercase;
      color: #ffffff;

      span {
        background: var(--text-gradient-165);
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
</style>
